import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { translatedMessage } from '../service/LanguageService';

const ValidationErrorModalComponent = (props) => {

  const dialogFooter = (
    <>
      <Button label={translatedMessage("generic.cancel")} icon="pi pi-times" className="p-button-text" onClick={() => props.closeDialog()} />
    </>
  );

  return (
    <Dialog
      visible={props.visible}
      header={props?.dialogTitle ? props.dialogTitle : translatedMessage("generic.error.validation.title")}
      modal
      footer={dialogFooter}
      className="pcn-dialog p-fluid"
      onHide={() => props.closeDialog()}
    >
      <div className="flex align-items-center">
        <i className="pi pi-exclamation-triangle mr-3 text-red-500" style={{ fontSize: '3rem' }} />
        <div className='w-full text-align-left align-items-center'>
          <div className="mb-2 font-bold">{props?.dialogInfo ? props.dialogInfo : translatedMessage("generic.error.validation.info")}</div>
          <ul>
            {Array.isArray(props?.errors) &&
              props?.errors?.map((item, index) => {
                let _translatedMessage = ""
                if(item?.param) {
                  _translatedMessage = translatedMessage(item.message, item.param)
                } else {
                  _translatedMessage = translatedMessage(item)
                }
                return (<li key={index} className='mb-2'>{_translatedMessage}</li>)
            })
            }
            {!Array.isArray(props?.errors) &&              
                <li key={1} className='mb-2'>{translatedMessage(props?.errors)}</li>              
            }
          </ul>
        </div>
      </div>
    </Dialog>

  );
};

export default ValidationErrorModalComponent;
